import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNewConfirmModal } from "modules/modals/hooks/useNewConfirmModal"
import { deleteTrip, duplicateTrip,updateTrip } from "store/trips"
import { notification } from "ui/Notification"
import { getActionTranslations } from "utils/translations"
import { loadingSelector } from "modules/loader-watchers/selectors"

const NOTIFICATION_DURATION = {
  success: 3000,
  error: 5000,
}

const triggerNotification = (type, message) => {
  notification[type]({
    message,
    type,
    closable: true,
    duration: NOTIFICATION_DURATION[type] || 3000
  })
}

export const useExperiencesActions = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { showConfirm, modal } = useNewConfirmModal()
  const loading = useSelector(loadingSelector("trips.trip"))
  const translations = getActionTranslations(t)

  const executeAction = async (trip, actionType, action) => {
    const { success, error } = translations[actionType]

    try {
      await dispatch(action(trip.id))
      triggerNotification('success', success)
    } catch {
      const type = actionType === 'duplicate' ? 'warning' : 'error'
      triggerNotification(type, error)
    }
  }

  const handleExperiencesAction = (trip, actionType, action) => {
    const {
      title,
      message,
      confirmLabel = t("global.confirm"),
      warningText
    } = translations[actionType]

    if (actionType === "duplicate") {
      executeAction(trip, actionType, action)
      return
    }

    showConfirm(
      {
        title,
        message,
        highlightText: trip.title,
        confirmLabel,
        cancelLabel: t("global.cancel"),
        ...(warningText && { warningText }),
        loading
      },
      () => executeAction(trip, actionType, action)
    )
  }

  return {
    handleDelete: (trip) => handleExperiencesAction(trip, "delete", deleteTrip),
    handleDuplicate: (trip) => handleExperiencesAction(trip, "duplicate", duplicateTrip),
    handleDeactivate: (trip) => handleExperiencesAction(trip, "deactivate", (id) => 
      updateTrip(id, { trip: { status: "unpublished" } })
    ),
    modal
  }
}
